//react
import { useUser } from "../../Providers/User";
import { useHistory } from "react-router";

//form
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//components
import Input from "../../Components/Input";
import { Container, BottonStyle } from "./styles";

//interfaces
import { IUserADMLogin } from "../../Interfaces";

export const LoginForm = () => {
  const { login } = useUser();
  let history = useHistory();

  const formSchema = yup.object().shape({
    email: yup.string().required("E-mail obrigatório"),
    password: yup.string().required("Senha obrigatória"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmit = (data: IUserADMLogin): void => {
    login(data, history, "/dashboard");
  };

  return (
    <Container>
      <form data-testid="formTestId" onSubmit={handleSubmit(onSubmit)}>
        <Input
          className="emailInput"
          label="E-mail"
          name="email"
          register={register}
          placeholder="E-mail"
        />
        {!!errors.email && <p className="error">{errors.email.message}</p>}
        <Input
          className="passwordInput"
          label="Senha"
          name="password"
          register={register}
          type="password"
          placeholder="Senha"
        />
        {!!errors.password && (
          <p className="error">{errors.password.message}</p>
        )}
        <BottonStyle type="submit" className="submit">
          Entrar
        </BottonStyle>
      </form>
    </Container>
  );
};
